/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from "@mui/icons-material/Add";
import { LoadingButton } from "@mui/lab";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import DatePicker from "../../components/DatePicker";
import TablePreloader from "../../components/Loader/TablePreloader";
import SearchBar from "../../components/SearchBar";
import Table from "../../components/table/Table";
import {
  getHospitals,
  setPagination,
} from "../../features/hospitals/hospitalSlice";
import UseHospital from "../../hooks/UseHospital";
import HomeLayout from "../../layouts/Home";
import config from "../../utils/config";
import { IError } from "../../utils/icons.utils";

const { routes } = config;
export default function Hospitals() {
  const {
    data,
    isLoading,
    dropdownMenu,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    loading,
    pagination,
  } = UseHospital();
  const dispatch = useDispatch();

  return (
    <HomeLayout {...{ title: "Hospital" }}>
      <Box data-cy="hospital-dashboard-page">
        <Box className="flex justify-between flex-col gap-6 sm:flex-col lg:flex-col xl:flex-row">
          <SearchBar
            {...{
              placeholder: "Search For Hospital",
              onChange: (e) => {
                const { value } = e.target;
                if (e.code === "Enter")
                  dispatch(getHospitals({ search: value }));
                else dispatch(setPagination({ search: value }));
              },
            }}
            data-cy="search-input"
          />
          <Box className="flex justify-between gap-4 sm:flex-col lg:flex-row flex-col">
            <LoadingButton
              LinkComponent={Link}
              className="w-[213px] h-[56px] bg-[var(--c-gray-4)] text-[var(--c-primary-0)] text-[18px] rounded-xl shadow-none normal-case"
              size="small"
              type="submit"
              variant="contained"
              fullWidth
              to={routes.hospitals.upload}
              data-cy="upload-hospital-btn"
            >
              Upload Hospital
            </LoadingButton>
            <LoadingButton
              LinkComponent={Link}
              className="w-[213px] h-[56px] bg-[var(--c-primary-0)] text-[600] text-[18px] rounded-xl shadow-none normal-case"
              size="small"
              type="submit"
              variant="contained"
              fullWidth
              startIcon={<AddIcon />}
              to={routes.hospitals.new}
              data-cy="add-hospital-btn"
            >
              Add Hospital
            </LoadingButton>
          </Box>
        </Box>
        <DatePicker
          {...{
            startDate,
            setStartDate,
            endDate,
            setEndDate,
          }}
        />
        <div className="w-full  mt-5">
          <Box
            className="pt-8 px-8 pb-2 rounded-lg bg-[var(--c-bg-color)] w-100%"
            sx={{ p: 0 }}
          >
            {isLoading ? (
              <TablePreloader />
            ) : data.length ? (
              <Table
                {...{
                  dropdownMenu,
                  data,
                  pagination,
                  setPagination: (d) => dispatch(setPagination(d())),
                  isLoading: loading,
                }}
              />
            ) : (
              <Box
                className="pt-8 pb-28 mt-8 bg-[var(--c-bg-color)] w-100% rounded-lg flex flex-col justify-center"
                sx={{ p: 0 }}
              >
                <img
                  className="m-auto w-[350px] mt-8"
                  src={IError}
                  alt={"error"}
                  loading="lazy"
                />
                <Typography className="flex justify-center text-[400] text-xl text-[#040316] mx-2 text-center">
                  No Hospitals in the system at the moment
                </Typography>
              </Box>
            )}
          </Box>
        </div>
      </Box>
    </HomeLayout>
  );
}
